export default __webpack_public_path__ + "static/media/email.4f887c36.svg";